import { Viewer as ViewerBase, type ViewerProps, type ViewerState } from '@seddi/ui-three-viewer';

import { degreeToRadian } from '../../core/units';
import { computeRotationFromCamera, getEnvironmentRotation } from '../../viewer/environment';
import { AppViewerTool, type CameraChangeData, type CameraChangeListener } from './appViewerTool';

export class Viewer extends ViewerBase<ViewerProps, ViewerState> {
  private cameraChangeListener: CameraChangeListener | null = null;

  componentDidMount() {
    super.componentDidMount();

    // Remove camera parent transform node (Author legacy).
    const { camera } = this;
    camera.parent = null;
    // Init camera tool.
    const canvas = this.canvasRef.current!;
    const tool = new AppViewerTool({ camera, canvas });
    this.tool = tool;

    // Create editor tool event listeners
    const cameraChangeListener = (event: CameraChangeData) => {
      // Compute environment rotation from camera.
      const cameraRotation = computeRotationFromCamera(event);
      // Update environment rotation.
      const { props, scene } = this;
      const environmentRotation = degreeToRadian(getEnvironmentRotation(props.scene));
      scene.environmentRotation.set(0, cameraRotation + environmentRotation, 0);
    };

    tool.addEventListener('cameraChange', cameraChangeListener);
    this.cameraChangeListener = cameraChangeListener;
  }

  componentWillUnmount() {
    // Remove editor tool event listeners
    const tool = this.tool as AppViewerTool | undefined;
    if (tool) {
      tool.removeEventListener('cameraChange', this.cameraChangeListener!);
    }
    this.cameraChangeListener = null;

    super.componentWillUnmount();
  }
}
